<template>
  <v-card class="pa-4">
    <v-card-title class="d-flex align-center mt-2 mb-2">
      <v-icon class="mr-2">mdi-cart</v-icon>
      <h3 class="mb-0">
        Seleccionar pedido - <strong>LPN {{ currentLpn }} </strong>
      </h3>
    </v-card-title>
    <v-card-text>
      <v-alert color="#D0EBFF" class="mb-4">
        <div class="d-flex justify-space-between align-center mb-0">
          <p class="mb-0 text-caption" style="font-size: 1rem !important;">
            Pedidos en el contenedor: {{ currentContainer?.orders.length || 0 }}
          </p>
          <v-chip variant="outlined" size="small">
            <p class="mb-0 text-caption" style="font-size: 1rem !important;">
              Pendientes: {{ pendingOrdersCount }}
            </p>
          </v-chip>
        </div>
      </v-alert>


      <div class="mb-4">
        <h5 class="font-weight-medium mb-3">
          Seleccione un pedido para procesar:
        </h5>
        <div class="space-y-3">
          <v-card v-for="(order, index) in currentContainer?.orders || []" :key="order.id"
            :ref="el => orderRefs[index] = el" tabindex="0" :class="[
              'cursor-pointer transition-colors elevation-0',
              isOrderCompleted(order) ? 'bg-green-50' : 'hover:bg-blue-50',
            ]" :variant="isOrderCompleted(order) ? 'tonal' : 'outlined'" :color="isOrderCompleted(order) ? 'success' : undefined"
            :loading="false" @click="!isOrderCompleted(order) && handleSelectOrder(order)"
            @keydown.enter="!isOrderCompleted(order) && handleSelectOrder(order)">
            <v-card-text class="py-3">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div :class="[
                    'text-h5 font-weight-bold',
                    isOrderCompleted(order) ? 'text-success-darken-2' : ''
                  ]">
                    <strong>#{{ order.code }}</strong>
                  </div>
                  <p class="subtext-card mb-0">
                    Cliente: {{ order.client.name }}
                  </p>
                  <p class="subtext-card mb-0">
                    {{ getTotalItems(order) }} items
                  </p>
                </div>
                <div class="d-flex align-center ga-2">
                  <v-chip v-if="isOrderCompleted(order)" variant="tonal" size="small">
                    <v-icon start size="small">mdi-check-circle</v-icon>
                    <h5 class="mb-0 pa-1">
                      Completado
                    </h5>
                  </v-chip>
                  <v-chip v-else variant="tonal" size="small">
                    <h6 class="mb-0 pa-1">Pendiente</h6>
                  </v-chip>
                  <v-icon v-if="order.status === 'pending'" color="medium-emphasis">
                    mdi-arrow-right
                  </v-icon>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </div>

      <v-btn @click="$emit('back-step')" variant="outlined" color="#2e3d45" size="large" block>
        <v-icon start>mdi-arrow-left</v-icon>
        Volver al Escaneo de LPN
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { shipmentOrderService } from '@/libs/ws/shipmentOrderService';

export default {
  name: "SelectOrder",
  props: {
    currentContainer: {
      type: Object,
      default: null,
    },
    currentLpn: {
      type: String,
      default: "",
    },
  },
  emits: ["order-selected", "back-step"],
  computed: {
    pendingOrdersCount() {
      return (
        // this.currentContainer.orders.length || 0
        this.currentContainer?.orders.filter(
          (order) => order.status.id === shipmentOrderService.STATUS_PREPARADO
        ).length || 0
      );
    },
  },
  data() {
    return {
      orderRefs: [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.orderRefs.length > 0) {
      this.orderRefs[0]?.$el?.focus();
          }
    });
  },
  methods: {
    handleSelectOrder(order) {
      this.$emit("order-selected", order);
    },
    getTotalItems(order) {
      return order.items.length;
    },
    isOrderCompleted(item) {
      return item.status.id === shipmentOrderService.STATUS_EMPAQUETADO;
    },
  },
};
</script>

<style scoped>
.space-y-3>*+* {
  margin-top: 12px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
